
import { Component, Vue } from "vue-property-decorator"
import { Action, Getter, State } from "vuex-class"
import { BaseState } from "@/store"

@Component({})
export default class NewLightDarkSwitch extends Vue {
	@State((state: BaseState) => state.darkMode) darkMode!: boolean
	@Getter("getUseV2") usingV2!: boolean

	@Action setTheme!: (darkMode: boolean) => void;

	get isDark () {
		// TODO re-enable dark mode on new interface once actively working on it again
		return !this.usingV2 && this.darkMode
	}

	set isDark (value: boolean) {
		this.setTheme(value)
	}

	/**
	 * Icon to display in centre of switch
	 * NOTE: Do not use Font Awesome names/classes here. Otherwise, the label text will be styled incorrectly
	 * @private
	 */
	private get icon (): "moon" | "sun" {
		return this.isDark ? "moon" : "sun"
	}
}
